import { useIsLoggedIn } from '@dreamstack/auth'
import { useTranslation } from '@dreamstack/i18n'
import { Download } from '@dreamstack/icons/src/icon-components/Download'
import { SimpleInput } from '@dreamstack/simple-components/src/lib/SimpleInput'
import type { FunctionComponent } from 'react'
import { Controller, FormProvider } from 'react-hook-form'
import { FormCheckbox } from '../forms/FormCheckbox'
import { SimpleMuiButton } from '../layout/SimpleMuiButton'
import { BodyText } from '../layout/Texts'
import { AccessFileErrorDialog } from './AccessFileErrorDialog'
import type { AccessFileFormData } from './useAccessFileFormSchema'

export const AccessFileForm: FunctionComponent<
  React.PropsWithChildren<{
    loading: boolean
    onSubmit: (data: AccessFileFormData) => Promise<void>
    control: any
    handleSubmit: any
    methods: any
  }>
> = ({ loading, onSubmit, control, handleSubmit, methods }) => {
  const t = useTranslation()
  const isLoggedIn = useIsLoggedIn()
  return (
    <>
      <AccessFileErrorDialog
        title={t('accentro:generalizedError.title')}
        text={t('accentro:generalizedError.body')}
        ctaLabel={t('accentro:generalizedError.cta')}
      />
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          {!isLoggedIn && (
            <div className="mb-px-32">
              <Controller
                defaultValue=""
                name="clientEmail"
                control={control}
                render={({ field }) => (
                  <SimpleInput
                    {...field}
                    label={`${t('accentro:contactform.email')}*`}
                    fullWidth
                  />
                )}
              />
              <div className="text-accentroGray-500 ">
                <BodyText className="text-px-13">
                  {t('accentro:contactform.requiredFieldsText')}
                </BodyText>
              </div>
            </div>
          )}
          <div className="space-y-px-32">
            {!isLoggedIn && (
              <div>
                <FormCheckbox
                  className="flex self-start"
                  propertyName="consent"
                  labelComponent={
                    <BodyText className="ml-px-12">
                      {`${t(
                        'accentro:homeOwnershipReportForm.consentDataPrivacy'
                      )}`}
                    </BodyText>
                  }
                />
              </div>
            )}
            <div>
              <FormCheckbox
                className="flex self-start"
                propertyName="subscribeNewsletter"
                labelComponent={
                  <BodyText className="ml-px-12">
                    {`${t(
                      'accentro:housingCostReportForm.consentNewsletterReceive'
                    )}`}
                  </BodyText>
                }
              />
            </div>
            <SimpleMuiButton
              variant="contained"
              type="submit"
              name="reportRequestSubmit"
              color="primary"
              disabled={loading}
              loading={loading}
              startIcon={
                isLoggedIn && <Download className="text-accentroWhite-full" />
              }
            >
              {!isLoggedIn
                ? t('accentro:housingCostReportForm.submitForm')
                : t('accentro:generalForm.submitButtonLoggedIn')}
            </SimpleMuiButton>
          </div>
        </form>
      </FormProvider>
    </>
  )
}
